<template>
  <v-dialog
    v-model="show"
    max-width="400"
    overlay-color="darktext"
    overlay-opacity="0.6"
  >
    <v-card>
      <v-card-title>
        {{ $t('confirmationDialogTitleLink') }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="submitDialogBtn()"
          @submit.prevent
        >
          <v-text-field
            v-model="urlLocal"
            data-testid="dialog-input"
            solo
            elevation="6"
            class="rounded-xxl text-body-2 pt-4"
            :placeholder="$t('confirmationDialogInputPlaceholderEmbedLink')"
            :hint="$t('confirmationDialogInputHintEmbedLink')"
            :rules="urlRules"
            :error-messages="errors"
          />
          <v-card-actions>
            <v-spacer />
            <v-btn
              ref="cancel"
              data-testid="cancel-button"
              color="darktext"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4"
              @click="show=false"
            >
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              ref="submit"
              data-testid="submit-button"
              type="submit"
              color="accent"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4"
              :loading="loading"
              @click="submitDialogBtn"
            >
              {{ $t('embed') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { ruleRequired } from '../rules/formRules.js';
import i18n from '../plugins/i18n'

const isUrl = require("is-valid-http-url");

export default {
  props: {
    visible: Boolean,
    url: {
        type: String,
        default: ''
    },
  },
  data(){
        return{
          alertMsg: '',
          valid: true,
          urlRules: ruleRequired('labelLink'),
          errors: [],
          val: '',
          loading: false
         }
    },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
          this.$refs.form.reset()
        }
      }
    },
    urlLocal: {
      get()
      {
          return this.val
      },
      set(url)
      {
          this.val = url
      }
    }
  },
  watch: {
    val(){
      if(isUrl(this.urlLocal) || this.urlLocal == '')
        {
          this.errors = []
        }else {
        this.errors = [i18n.t('linkErrorValid')]
      }
    }
  },
    created(){
      this.urlLocal = this.url
    },
  methods: {
    submitDialogBtn() {
      this.valid = this.$refs.form.validate()
      if(this.valid){
        if(!isUrl(this.urlLocal)){
          this.errors = [i18n.t('linkErrorValid')]
        }else {
          this.loading = true
          this.$emit('proceedSubmit', this.urlLocal)
        }        
      }
    }
  }
}
</script>